module.exports = __webpack_public_path__ + "static/media/hamburger.e45056e5.svg";